module.exports = __webpack_public_path__ + "static/images/shrink.3WnCmE9.svg";